import qs from 'qs'

import { HttpService, HttpServiceResponse } from '../shared'
import {
  EventActions,
  BeforeClientAddEditParams,
  BeforeLoanAddParams,
  BeforeLoanAddServerData,
  BeforeLoanDisburseParams,
  BeforeLoanDisburseServerData,
  BeforeEntryAddEditParams,
  BeforeEntryAddEditServerData,
  BeforeConvAddEditParams,
  BeforeConvAddEditServerData,
  BeforeLoanCoverParams,
  BeforeLoanCoverServerData,
  BeforeLoanVisaParams,
  BeforeLoanVisaServerData,
  BeforeCollateralAddEditParams,
  BeforeCollateralAddEditServerData,
  BeforeUccPayParams,
  BeforeUccPayServerData,
  EventsViewParams,
  EventsViewServerData,
} from './event.types'

export class EventProvider {
  private get url(): string {
    return `${this.baseUrl}/events_api.php`
  }

  constructor(private http: HttpService, private baseUrl: string) {}

  public beforeClientAddEdit(params: BeforeClientAddEditParams): Promise<HttpServiceResponse<void>> {
    const query = qs.stringify({ action: EventActions.BEFORECLIENTADDEDIT })

    return this.http.post(`${this.url}?${query}`, params)
  }

  public beforeLoanAdd(params: BeforeLoanAddParams): Promise<HttpServiceResponse<BeforeLoanAddServerData>> {
    const query = qs.stringify({ action: EventActions.BEFORELOANADD })

    return this.http.post(`${this.url}?${query}`, params)
  }

  public beforeLoanDisburse(
    params: BeforeLoanDisburseParams,
  ): Promise<HttpServiceResponse<BeforeLoanDisburseServerData>> {
    const query = qs.stringify({ action: EventActions.BEFORELOANDISBURSE })

    return this.http.post(`${this.url}?${query}`, params)
  }

  public beforeEntryAddEdit(
    params: BeforeEntryAddEditParams,
  ): Promise<HttpServiceResponse<BeforeEntryAddEditServerData>> {
    const query = qs.stringify({ action: EventActions.BEFOREENTRYADDEDIT })

    return this.http.post(`${this.url}?${query}`, params)
  }

  public beforeConvAddEdit(params: BeforeConvAddEditParams): Promise<HttpServiceResponse<BeforeConvAddEditServerData>> {
    const query = qs.stringify({ action: EventActions.BEFORECONVADDEDIT })

    return this.http.post(`${this.url}?${query}`, params)
  }

  public beforeLoanCover(params: BeforeLoanCoverParams): Promise<HttpServiceResponse<BeforeLoanCoverServerData>> {
    const query = qs.stringify({ action: EventActions.BEFORELOANCOVER })

    return this.http.post(`${this.url}?${query}`, params)
  }

  public beforeLoanVisa(params: BeforeLoanVisaParams): Promise<HttpServiceResponse<BeforeLoanVisaServerData>> {
    const query = qs.stringify({ action: EventActions.BEFORELOANVISA })

    return this.http.post(`${this.url}?${query}`, params)
  }

  public beforeCollateralAddEdit(
    params: BeforeCollateralAddEditParams,
  ): Promise<HttpServiceResponse<BeforeCollateralAddEditServerData>> {
    const query = qs.stringify({ action: EventActions.BEFORECOLLATERALADDEDIT })

    return this.http.post(`${this.url}?${query}`, params)
  }

  public beforeUccPay(params: BeforeUccPayParams): Promise<HttpServiceResponse<BeforeUccPayServerData>> {
    const query = qs.stringify({ action: EventActions.BEFOREUCCPAY })

    return this.http.post(`${this.url}?${query}`, params)
  }

  public view(params: EventsViewParams): Promise<HttpServiceResponse<EventsViewServerData>> {
    const query = qs.stringify({ action: EventActions.VIEW })

    return this.http.post(`${this.baseUrl}/events_view_api.php?${query}`, params)
  }
}
